import { render, staticRenderFns } from "./DiagramNodeTitle.vue?vue&type=template&id=540443e7&"
import script from "./DiagramNodeTitle.vue?vue&type=script&lang=js&"
export * from "./DiagramNodeTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports